import React, { Component } from 'react';
import { Route,  Switch } from 'react-router-dom';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import Icon from '../../components/Icon';

import PageNotFound from '../PageNotFound';
import InstallationUsage from '../InstallationUsage';
import BestPractices from '../BestPractices';
import Accessibility from '../Accessibility';
import Grid from '../Grid';
import Typography from '../Typography';
import Forms from '../Forms';
import Buttons from '../Buttons';
import Containers from '../Containers';
import Tables from '../Tables';
import Calendar from '../Calendar';
import Tabs from '../Tabs';
import Markdown from '../Markdown';
import Brand from '../Brand';

class BCS extends Component {

    constructor(props) {
        super(props);

        this.state = {
            active: false,
            includeNav: true,
            condenseNav: true,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({active: false});
    }

    removeNav = () => {
        this.setState({ includeNav: false });
    }

    includeNav = () => {
        this.setState({ includeNav: true });
    }

    toggleNav = () => {
        const currentState = this.state.active;
        this.setState({ active: !currentState });
    };

    condenseNav = () => {
        const condenseNav = !this.state.condenseNav
        this.setState({condenseNav});
    }

    render() {

        return (
            <React.Fragment>
              {this.state.includeNav ? (
                  <React.Fragment>
                    <div
                        className={`nav-toggle hide-md ${this.state.condenseNav ? 'condensed' : ''}`}
                        title={this.state.active ? 'Show navigation menu' : 'Hide navigation menu'}
                        role="button"
                        tabIndex="0"
                        aria-expanded={this.state.active}
                        aria-label={this.state.active ? 'Show navigation menu' : 'Hide navigation menu'}
                        onClick={(e)=>this.toggleNav(e)}
                    >
                        <div className={`hide-md nav-toggle-open ${ this.state.active ? 'open' : '' }`}>
                            <span></span><span></span><span></span><span></span>
                        </div>
                    </div>
                    <div
                        className={`nav-toggle hide-xs show-md ${this.state.condenseNav ? 'condensed' : ''}`}
                        onClick={() => this.condenseNav()}
                        title={this.state.condenseNav ? 'Expand navigation menu' : 'Condense navigation menu'}
                        role="button"
                        tabIndex="0"
                        aria-expanded={this.state.condenseNav}
                        aria-label={this.state.condenseNav ? 'Expand navigation menu' : 'Condense navigation menu'}
                    >
                        <div className="nav-flyout">
                            <Icon icon="arrow-right"/>
                            <Icon icon="arrow-left"/>
                        </div>
                    </div>
                    <Navigation {...this.props} active={this.state.active} condenseNav={this.state.condenseNav}/>
                  </React.Fragment>
              ) : null }
              <Header {...this.props} active={this.state.active} toggleNav={this.toggleNav}  condenseNav={this.state.condenseNav}/>
              <main className={`bcs-app-content ${this.state.condenseNav ? 'expanded' : ''}`} style={this.state.includeNav ? null : {'margin': 0}} data-component="bcs" id="main-content">
                      <div className="bcs-app-content-inner">
                          <Switch>
                              <Route exact path='/' render={(props) => (
                                  <InstallationUsage {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/best-practices' render={(props) => (
                                  <BestPractices {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/accessibility' render={(props) => (
                                  <Accessibility {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/grid' render={(props) => (
                                  <Grid {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/typography' render={(props) => (
                                  <Typography {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/forms' render={(props) => (
                                  <Forms {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/buttons' render={(props) => (
                                  <Buttons {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/containers' render={(props) => (
                                  <Containers {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/tables' render={(props) => (
                                  <Tables {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/calendar' render={(props) => (
                                  <Calendar {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/tabs' render={(props) => (
                                  <Tabs {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/markdown' render={(props) => (
                                  <Markdown {...props} includeNav={this.includeNav}/>
                              )}/>
                              <Route exact path='/brand' render={(props) => (
                                  <Brand {...props} includeNav={this.includeNav}/>
                              )}/>

                              <Route component={PageNotFound} />
                          </Switch>
                      </div>
                      <Footer {...this.props} />
                  </main>

            </React.Fragment>
        )
    }
}

export default BCS;



// WEBPACK FOOTER //
// ./src/pages/BCS/index.js